module.exports = __webpack_public_path__ + "img/check_gold.4c811066.png";